import { ToastrService } from 'ngx-toastr';
import { GradebookDataService } from '../../../../Services/gradebookData.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GradeDialogComponent } from '../../shared/grade-dialog/grade-dialog.component';
import { IServiceFactory } from '../../../../Services/service-factory';
import { environment } from '../../../../../environments/environment';
import { ReassignDialogComponent } from '../../shared/reassign-dialog/reassign-dialog.component';
import { AssignmentStudentAttempt, LessonProgressSaveGradeModel, UnAssignModel } from 'src/app/Elearning-Models';
import { IAPIService } from 'src/app/Services/API-Service/IAPIService';

import { UnassignDiaglogComponent } from '../../shared/unassign-diaglog/unassign-diaglog.component';

import { CSSLabel, ColorCodes, StatusLabel } from 'src/app/ColorCodes';
import { AssignmentAttemptsViewWorkDialogComponent } from 'src/app/layouts/view-work/assignment-attempts-view-work-dialog/assignment-attempts-view-work-dialog.component';


@Component({
  selector: 'assignment-card',
  templateUrl: './assignment-card.component.html',
  styleUrls: ['./assignment-card.component.scss'],
})
export class AssignmentCardComponent implements OnInit {
  @Input() assignment: AssignmentStudentAttempt;
  @Input() classID: number;

  completionStatus: string;
  colorCode: string;
  colorIndicators = new ColorCodes().colorIndicators;

  canReleaseGrade: boolean;
  canReleaseAnswerKey: boolean;

  constructor(
    private datePipe: DatePipe,
    private router: Router,
    private dialog: MatDialog,
    private serviceFactory: IServiceFactory,
    private APIService: IAPIService,
    private toastr: ToastrService
  ) {
  }

  ngOnInit(): void {
    this.checkReleaseStatus();
    this.dateTransform();
    this.calculateCompletionStatus();
    this.GetColorLabel();
    if(this.assignment.SubmittedAsComplete && !this.assignment.CompleteDate)
    {
      this.assignment.Status = "Locked";
    }
  }

  dateTransform = () => {
    if (this.assignment.CompleteDate) {
      this.assignment.CompleteDate = this.datePipe.transform(
        new Date(this.assignment.CompleteDate),
        'MM-dd-yyyy'
      );
    }
    this.assignment.StartDate = this.datePipe.transform(
      new Date(this.assignment.StartDate),
      'MM-dd-yyyy'
    );
    this.assignment.DueDate = this.datePipe.transform(
      new Date(this.assignment.DueDate),
      'MM-dd-yyyy'
    );
  };

  calculateCompletionStatus = () => {
    if (this.assignment.CompleteDate) {
      if (
        Date.parse(this.assignment.CompleteDate) >
        Date.parse(this.assignment.DueDate)
      ) {
        this.completionStatus = 'delay';
      } else {
        this.completionStatus = 'onTime';
      }
    } else {
      this.completionStatus = 'none';
    }
  };

  onViewWork = () => {
    // this.router.navigate([environment.rootPath + 'ViewWork'], {
    //   queryParams: {
    //     AttemptID: this.assignment.AttemptID,
    //     AssignmentID: this.assignment.AssignmentID,
    //     AssignmentName: this.assignment.LessonName,
    //     StudentName: this.assignment.StudentName
    //   },
    // });

    const dialogRef = this.dialog.open(AssignmentAttemptsViewWorkDialogComponent, {
      data: {
        okString: "Close",
        cancelString: "",
        attemptID: this.assignment.AttemptID,
        assignmentID: this.assignment.AssignmentID,
        assignmentName: this.assignment.LessonName,
        studentName: this.assignment.StudentName,
        studentID: this.assignment.StudentID
      },
    });

    const sub = dialogRef.componentInstance.valueUpdated.subscribe(
      (yes) => {
        if(yes){

        }
      });

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }

  onAssignmentClick = () => {
    this.router.navigate(
      [environment.rootPath + 'Assignment/' + this.assignment.LessonID],
      { queryParams: { assignmentName: this.assignment.LessonName } }
    );
  };

  releaseGradeChanged = (tg) => {
    this.APIService.ReleaseGradeForStudent({
      ClassID: this.classID,
      AssignmentID: this.assignment.AssignmentID,
      StudentID: this.assignment.StudentID
    }).subscribe((response) => {
      if (response) {
        this.assignment.GradeReleased = tg.checked;
        this.GetColorLabel();
        if(this.assignment.GradeReleased) {
          this.toastr.success('Grade Released', 'Success!');
        } else {
          this.toastr.success('Grade Release Reversed', 'Success!');
        }
      } else {
        tg.checked = this.assignment.GradeReleased;
        this.toastr.error('Something went wrong', 'Failure!');
      }
    });
  };

  releaseAnswerKeyChanged = (tak) => {
      this.APIService.ReleaseKeyForStudent({
        ClassID: this.classID,
        AssignmentID: this.assignment.AssignmentID,
        StudentID: this.assignment.StudentID,
      }).subscribe((response) => {
        if (response) {
          this.assignment.AnswerKeyReleased = tak.checked;
          if(this.assignment.AnswerKeyReleased) {
            this.toastr.success('Answer Key Released', 'Success!');
          } else {
            this.toastr.success('Answer Key Release Reversed', 'Success!');
          }
        } else {
          tak.checked = this.assignment.AnswerKeyReleased;
          this.toastr.error('Something went wrong', 'Failure!');
        }
      });
  };

  lockAssignmentChanged = (tl) => {
    this.APIService.LockAssignmentForStudent({
      ClassID: this.classID,
      AssignmentID: this.assignment.AssignmentID,
      StudentID: this.assignment.StudentID,
      Lock: tl.checked
    }).subscribe((response) => {
      if (response) {
        this.assignment.SubmittedAsComplete = tl.checked;
        this.GetColorLabel();
        if(this.assignment.SubmittedAsComplete) {
          this.toastr.success('Assignment Locked', 'Success!');
        } else {
          this.toastr.success('Assignment Unlocked', 'Success!');
        }
      } else {
        tl.checked = this.assignment.SubmittedAsComplete;
        this.toastr.error('Something went wrong', 'Failure!');
      }
    });

  };

  canReleaseGradeCheck = () => {
    return this.assignment.Graded;
  };

  canReleaseAnswerKeyCheck = () => {
    return this.assignment.SubmittedAsComplete || this.assignment.Graded;
  };

  checkReleaseStatus = () => {
    this.canReleaseGrade = this.canReleaseGradeCheck();
    this.canReleaseAnswerKey = this.canReleaseAnswerKeyCheck();
  };

  onGradeClick = () => {
    this.openGradeDialog();
  };

  openGradeDialog = () => {
    const dialogRef = this.dialog.open(GradeDialogComponent, {
      data: {
        grade: this.assignment.Grade,
        title: this.assignment.LessonName,
      },
      autoFocus: false,
    });

    const sub = dialogRef.componentInstance.valueUpdated.subscribe(
      (assignment) => {
        
        if (assignment.Grade !== null) 
        {
          var model = new LessonProgressSaveGradeModel();
          model.AssignmentID = this.assignment.AssignmentID;
          model.ClassID = this.classID;
          model.StudentID = this.assignment.StudentID;
          model.FeedbackText = assignment.feedbackText ?? "";
          model.Grade = assignment.grade;

          this.APIService.SaveGradeForStudent(model).subscribe((response) => {
            if(response) {
              this.assignment.Graded = true; 
              this.assignment.Grade = assignment.grade;
              this.toastr.success('Student Graded', 'Success!');
              this.GetColorLabel();
            } else {
              this.toastr.error('Something went wrong', 'Failure!');
            }
          });
        } else {
          // this.assignment.Graded = false;
        }
        this.checkReleaseStatus();
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  };

  onReassignClick = () => {
    const dialogRef = this.dialog.open(ReassignDialogComponent, {
      data: {
        assignment: {
          grade: this.assignment.Grade,
          gradeReleased: this.assignment.GradeReleased,
          answerKeyReleased: this.assignment.AnswerKeyReleased,
        },
        title: this.assignment.LessonName,
      },
      autoFocus: false,
    });

    const sub = dialogRef.componentInstance.reassignSelected.subscribe(
      (selectedValues) => {
        this.APIService.ReassignStudent({
          ClassID: this.classID,
          AssignmentID: this.assignment.AssignmentID,
          StudentID: this.assignment.StudentID,
          ReassignShowIcon: selectedValues.selectedOption,
          ReassignShowAnswer: selectedValues.subOption,
        }).subscribe((response) => {
          if (response) {
            this.toastr.success('Student Reassigned', 'Success!');
            this.GetColorLabel();
          } else {
            this.toastr.error('Something went wrong', 'Failure!');
          }
        });
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  };

  openUnassignDialog()
  {
    const dialogRef = this.dialog.open(UnassignDiaglogComponent, {
      data: {
        lessonName: this.assignment.LessonName,
        studentName: this.assignment.StudentName,
      },
      autoFocus: false,
    });


    const sub = dialogRef.componentInstance.unassignYes.subscribe(
      (result: boolean) => {
        if(result){
          this.onUnassignClick();
        }
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }


  onUnassignClick = () => {
    var model = new UnAssignModel();
    model.ClassID = this.classID;
    model.LessonVersionID = this.assignment.LessonID;
    model.StudentID = this.assignment.StudentID;
    this.APIService.UnassignOneOrAllAssignments(model).subscribe(result => {
      if(result){
        this.toastr.success(this.assignment.LessonName + " was successfully unassigned from " + this.assignment.StudentName);
      }
      else{
        this.toastr.error('Something went wrong', 'Failure!');
      }
    });
  };


  private GetColorLabel() {
    var label: string;
    if (this.assignment.Grade && this.assignment.GradeReleased) {
      label = StatusLabel.Graded;
    }
    else if (this.assignment.Grade && !this.assignment.GradeReleased) {
      label = StatusLabel.GradeNotReleased;
    }
    else if (
      !this.assignment.Grade 
      && !this.assignment.GradeReleased 
      && this.assignment.SubmittedAsComplete) {
      label = StatusLabel.Ungraded;
    }
    else {
      // no sent back
      label = StatusLabel.Assigned;
    }

    if (this.assignment.SentBack) {
      label = StatusLabel.SentBack;
    }
    this.colorCode = this.getColorCode(label);
    if(this.assignment.Status != "Started"){
      this.assignment.Status = label;
    }
  }

  getColorCode(label : string){
    return this.colorIndicators.find(color => color.label == label)?.color;
  }

}
